import * as React from "react"
import { ModalCmp } from "../config/interfaces";

export default ({ refButton }: ModalCmp) => {
    const [isVisbleModal, setIsVisbleModal] = React.useState<boolean>(false)

    const setHandlerButton = () => {
        refButton.current.onclick = function () {
            setIsVisbleModal(true)
        }
    }

    const hideModal = () => {
        setIsVisbleModal(false)
    }

    // Aditional
    const getId = (url: string): string => {
        let mapId = url.replace(/^(\w|\W)+v=(\w+)(&.*)?/gi, '$2')
        return mapId
    }

    React.useEffect(() => {
        setHandlerButton();
    })

    return (
        <section className={`modal${!isVisbleModal ? ' hide' : ''}`}>
            <div className="modal__container modal__container--video">
                <span className="modal__close" data-modal-close onClick={hideModal}></span>
                {refButton.current && isVisbleModal &&
                    <iframe width="560" height="600" src={`https://www.youtube.com/embed/${getId(refButton.current.dataset.content)}`}
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen>
                    </iframe>
                }
            </div>
        </section>
    )
}